<template>
	<ParamDispatcher
		v-bind="$attrs"
		v-on="$listeners"
		:node="node"
		:nodeService="nodeService"
		:nodeAction="nodeAction"
		:workflowVersion="workflowVersion"
		:hasEditPermissions="hasEditPermissions"
	/>
</template>

<script>
import { mapGetters } from 'vuex';
import AppService from '@/utils/AppService';
// import ParamDispatcher from './ParamDispatcher';
import { getService } from '@/store/modules/apps/getters';
import { getAction } from '@/store/modules/actions/getters';
import * as WorkflowNodeService from '@/utils/workflow-node-service';
import { isConfigurationsOn } from '@/store/modules/featureFlags/getters';
import { canEditWorkflow } from '@/store/modules/workflows/getters';
import { getConfigurationFieldResponse } from '@/store/modules/workflowConfigurations/getters';
import { editedWorkflowVersion, selectedWorkflowId } from '@/store/modules/selectedWorkflow/getters';
import { getAccountConnection } from '@/store/modules/credentials/getters';

export default {
	name: 'ParamDispatcherDataProvider',
	props: {
		node: { type: Object },
	},
	components: { ParamDispatcher: () => import('./ParamDispatcher.vue') },
	computed: {
		...mapGetters([
			getService.fullPath,
			getAction.fullPath,
			editedWorkflowVersion.fullPath,
			selectedWorkflowId.fullPath,
			canEditWorkflow.fullPath,
			getConfigurationFieldResponse.fullPath,
			isConfigurationsOn.fullPath,
			getAccountConnection.fullPath,
		]),
		nodeService() {
			return this[getService.fullPath](this.node.service);
		},
		nodeAction() {
			return this[getAction.fullPath](this.node.action);
		},
		workflowVersion() {
			return this[editedWorkflowVersion.fullPath];
		},
		hasEditPermissions() {
			return this[canEditWorkflow.fullPath](this[selectedWorkflowId.fullPath]) && !this.isLocked;
		},
		isLocked() {
			const skipAuthCheck = this.nodeAction?.skip_auth;
			return !skipAuthCheck && AppService.doesRequiresAuth(this.nodeService) && !this.currentConnection;
		},
		nodeCredentialsId() {
			return WorkflowNodeService.getNodeRelevantCredsId(
				this.workflowVersion,
				this.node,
				this[getConfigurationFieldResponse.fullPath],
				this[isConfigurationsOn.fullPath]
			);
		},
		currentConnection() {
			if (!this.nodeCredentialsId) {
				return null;
			}
			return this[getAccountConnection.fullPath](this.nodeCredentialsId);
		},
	},
};
</script>
